import { format } from "date-fns";

const calculateDueMonths = (payments = [], startDate = "01-01-2025") => {
	const dueMonths = [];
	const now = new Date();
	const current = new Date(startDate);

	// Extract paid months from subscriptionPayment
	const paidMonths = new Set(
		payments.map((p) => format(new Date(p.payment_month), "yyyy-MM")),
	);

	// Loop from start to current month
	while (
		current.getFullYear() < now.getFullYear() ||
		(current.getFullYear() === now.getFullYear() &&
			current.getMonth() <= now.getMonth())
	) {
		const monthStr = format(current, "yyyy-MM");
		if (!paidMonths.has(monthStr)) {
			dueMonths.push(new Date(current));
		}
		// Move to next month
		current.setMonth(current.getMonth() + 1);
	}
	return dueMonths;
};

export default calculateDueMonths;
